document.addEventListener('click', (event) => {
  const link = event.target.closest?.('#header-sidebar-menu a[href]');
  if (!link) return;
  const drawer = link.closest('navigation-drawer');
  const destination = new URL(link.href, location.href);
  if (destination.pathname === location.pathname && destination.hash) {
    drawer.addEventListener('dialog:after-hide', () => {
      document.getElementById(decodeURIComponent(destination.hash.slice(1)))?.scrollIntoView({block: 'start'});
    }, {once: true});
  }
  drawer.querySelector('button[is="close-button"]')?.click();
});

document.addEventListener('click',event=>{
 const link=event.target.closest?.('.ls-nav-disclosure a[href]');
 if(!link)return;
 const destination=new URL(link.href,location.href);
 if(destination.pathname===location.pathname&&destination.hash){
  const menu=link.closest('.ls-nav-disclosure');
  menu.open=false;
  const target=document.getElementById(decodeURIComponent(destination.hash.slice(1)));
  if(target){target.scrollIntoView({block:'start'});if(!target.hasAttribute('tabindex'))target.tabIndex=-1;target.focus({preventScroll:true});}
 }
});

function bindMenuModelPicker(){
 document.querySelectorAll('.ls-mobile-models--home').forEach(track=>{
  if(track.dataset.pickerReady)return;
  track.dataset.pickerReady='true';
  const nav=track.closest('.ls-mobile-nav'),buttons=[...nav.querySelectorAll('[data-menu-model-select]')],cards=[...track.querySelectorAll('[data-menu-model]')];
  buttons.forEach(button=>button.addEventListener('click',()=>{
   const card=cards.find(item=>item.dataset.menuModel===button.dataset.menuModelSelect);
   if(!card)return;
   track.scrollTo({left:track.scrollLeft+card.getBoundingClientRect().left-track.getBoundingClientRect().left-1,behavior:'instant'});
   buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  }));
  let frame;
  track.addEventListener('scroll',()=>{
   cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
    const left=track.getBoundingClientRect().left;
    const nearest=cards.reduce((best,card)=>Math.abs(card.getBoundingClientRect().left-left)<Math.abs(best.getBoundingClientRect().left-left)?card:best,cards[0]);
    buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.menuModelSelect===nearest.dataset.menuModel)));
   });
  },{passive:true});
 });
}
bindMenuModelPicker();
document.addEventListener('DOMContentLoaded',bindMenuModelPicker,{once:true});
document.addEventListener('shopify:section:load',bindMenuModelPicker);

function syncMenuHeader(){
 const drawer=document.getElementById('header-sidebar-menu'),header=document.querySelector('store-header.header');
 if(!drawer||!header)return;
 const toggle=header.querySelector('[aria-controls="header-sidebar-menu"]'),row=header.querySelector('.header__wrapper'),utility=header.querySelector('.luxsol-header__utility');
 if(!toggle||!row)return;
 const rect=toggle.getBoundingClientRect(),headerRect=header.getBoundingClientRect();
 drawer.style.setProperty('--ls-menu-toggle-left',rect.left+'px');
 drawer.style.setProperty('--ls-menu-toggle-top',(rect.top-headerRect.top)+'px');
 drawer.style.setProperty('--ls-menu-toggle-width',rect.width+'px');
 drawer.style.setProperty('--ls-menu-toggle-height',rect.height+'px');
 drawer.style.setProperty('--ls-menu-row-height',row.getBoundingClientRect().height+'px');
 drawer.style.setProperty('--ls-menu-utility-height',(utility?.getBoundingClientRect().height||0)+'px');
 for(const [name,selector] of [['logo','.header__logo'],['actions','.header__secondary-nav']]){
  const bounds=header.querySelector(selector).getBoundingClientRect();
  for(const [axis,value] of Object.entries({left:bounds.left,top:bounds.top-headerRect.top,width:bounds.width,height:bounds.height}))drawer.style.setProperty('--ls-menu-'+name+'-'+axis,value+'px');
 }
 const sourceItems=[...header.querySelectorAll('.luxsol-header__utility-item')];
 drawer.querySelectorAll('.luxsol-header__utility-item').forEach((item,index)=>{
  const active=sourceItems[index]?.classList.contains('is-active');
  item.classList.toggle('is-active',Boolean(active));
  item.setAttribute('aria-hidden',String(!active));
  if(item.matches('a'))item.tabIndex=active?0:-1;
 });
}
document.addEventListener('click',event=>{
 if(event.target.closest?.('store-header [aria-controls="header-sidebar-menu"]'))syncMenuHeader();
},true);
window.addEventListener('resize',()=>{
 if(document.getElementById('header-sidebar-menu')?.open)syncMenuHeader();
},{passive:true});
